import React, { Fragment } from "react";
import {
  List,
  Link,
  Datagrid,
  Filter,
  EditButton, Pagination,
  useRecordContext,
  Button,
  TextInput,
  TextField,
  ShowButton,
  TopToolbar,
  DateInput,
  FunctionField,
  useListContext


} from "react-admin";
import { makeStyles } from '@material-ui/core';
import BulkRejectButton from '../UserCommands/Action/Bulk.Reject.Button';
import DownloadIcon from '@material-ui/icons/GetApp';
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'
import { PitTaskStatusSelectInput } from '../../UI/Input/SelectInput'

const ListFilter = (props) => {
  const {

    setFilters,
    hideFilter
  } = useListContext();
  return (<Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <DateInput source="current_date" lable="Date" alwaysOn />
     <PitTaskStatusSelectInput label="Status" source="status" />

  </Filter>)
};



const ProfileidFiled = (props) => {
  const record = useRecordContext();
  return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
  )
}



// const BulkActionButtons = ({ gift_id, ...props }) => {

//   return (<Fragment>

//     <BulkRejectButton label="Bulck Delete"  {...props} />
//   </Fragment>)
// }

const ListActions = () => (
  <TopToolbar>
    <Button href={'//sboportal.org.in/admin/api/v1/prouctintenttestertask/export?'} label="Export" ><DownloadIcon /></Button>
  </TopToolbar>
);

const PostPagination = ({ record, ...props }) => {
  return (<Pagination rowsPerPageOptions={[10, 20, 30, 200, 500,]} {...props} />)
}

const ProductIntentTesterTaskList = ({ ...props }) => {
  const classes = useStyles()
  const [userstatusCreate, setUserStatusCreate] = React.useState(null)
  const handleStatusSelect = (record) => {
    setUserStatusCreate({ record: record })
  }

  return (
    <Fragment>
      <List
        {...props}
        pagination={<PostPagination />}
        title="Product Intent Tester Task"
        filters={<ListFilter />}
        sort={{ field: "name", order: "ASC" }}
       
        actions={<ListActions />}
      >
        <Datagrid >
          <TextField source="id" />
          <ProfileidFiled source="profile_id" label="Profile ID" />
          <TextField source="name" label="Name" />
          <TextField source="radio_label1" label="Question 1" />
          <TextField source="radio_label2" label="Question 2" />
          <TextField source="task_amount" label="Amount" />
          <FunctionField source="status" label="Status" render={record => {

            if (record['status'] === 'Reject') {
              return (<span style={{ color: 'red' }}>Reject</span>)
            } else if (record['status'] === 'Pending') {
              return (<span style={{ color: 'orange' }} >Pending</span>)
            }
            else {
              return (<span style={{ color: 'green' }}>Approved</span>)
            }
          }} />
          <TextField source="created_at" label="Date" />          
          {useCheckPermissions('ProductIntentTesterTask_View') ? <ShowButton /> : null}
        </Datagrid>
      </List>

    </Fragment>
  );
};
const useStyles = makeStyles({
  numberCell: { width: 60 },
  actionCell: { width: 100 },
  layoutCell: { width: 120 }
})
export default ProductIntentTesterTaskList;
